import {
  ColumnDefinition,
  OuiButtonComponent,
  OuiDataTableComponent,
  OuiPaginatorComponent,
  PageRequest,
  OuiServerSideDatasource as OuiDatasource,
  OuiStackComponent,
  OuiTextComponent,
} from '@aiz-gl/omni-ui';
import { Component, effect, inject, TemplateRef, viewChild } from '@angular/core';
import { RmaService } from '../../services/rma/rma.service';
import { RmaSummaryRow } from '../../services/rma/rma.mapper';
import { BasePageComponent } from '../base/base.component';

@Component({
  selector: 'app-pending-approval',
  standalone: true,
  imports: [
    OuiButtonComponent,
    OuiDataTableComponent,
    OuiPaginatorComponent,
    OuiStackComponent,
    OuiTextComponent,
  ],
  templateUrl: './pending-approval.component.html',
  styleUrls: ['./pending-approval.component.css'],
})
export class PendingApprovalPage extends BasePageComponent {
  rmaNumberCell = viewChild<TemplateRef<never>>('rmaNumberCell');
  statusCell = viewChild<TemplateRef<never>>('statusCell');

  private readonly rmaService = inject(RmaService);
  private lastRegionId?: number;

  private readonly pendingApprovalDataLoader = (request: PageRequest) =>
    this.rmaService.rmaDataLoader({
      ...request,
      sortColumn: request.sortColumn === 'date' ? 'Date' : request.sortColumn || 'Date',
      sortDirection:
        request.sortDirection && request.sortDirection !== 'indet'
          ? request.sortDirection
          : 'desc',
      filter: {
        ...(request.filter ?? {}),
        isMyRmas: true,
        status: ['Under Review'],
      },
    });

  columns!: ColumnDefinition<RmaSummaryRow>[];

  datasource = new OuiDatasource<RmaSummaryRow>(this.pendingApprovalDataLoader);

  constructor() {
    super();

    this.datasource.sortRecords({
      column: 'date',
      direction: 'desc',
    });

    effect(() => {
      this.columns = [
        {
          columnDef: 'rmaNumber',
          header: 'RMA #',
          template: this.rmaNumberCell(),
        },
        { columnDef: 'rmaType', header: 'Type' },
        { columnDef: 'order', header: 'Order' },
        { columnDef: 'dcc', header: 'DCC' },
        { columnDef: 'warehouse', header: 'WH' },
        { columnDef: 'channel', header: 'Channel' },
        { columnDef: 'createdBy', header: 'Created By' },
        { columnDef: 'date', header: 'Date' },
        {
          columnDef: 'status',
          header: 'Status',
          template: this.statusCell(),
        },
      ];
    });

    effect(() => {
      const regionId = this.regions.selectedRegionId();
      if (!regionId) {
        return;
      }

      if (this.lastRegionId == null) {
        this.lastRegionId = regionId;
        return;
      }

      if (this.lastRegionId === regionId) {
        return;
      }

      this.lastRegionId = regionId;
      this.datasource.setFilter({
        isMyRmas: true,
        status: ['Under Review'],
      });
    });
  }

  openRmaDetails(rmaId: number) {
    this.router.navigate(['/rma-management/summary', rmaId]);
  }

  goBackToSummary() {
    this.router.navigate(['/rma-management/summary']);
  }

  getStatusClass(status: string | undefined): string {
    const normalized = (status || '').trim().toLowerCase();

    if (normalized.includes('pending') || normalized.includes('under review')) {
      return 'rma-status-chip rma-status-chip--pending';
    }

    return 'rma-status-chip';
  }
}
